import * as React from 'react';
import { InlineText2 } from '@cian/ui-kit';
import { INewBuildingApartment } from '../../types/newBuldings/apartments';
import * as styles from './ApartmentsList.css';

interface IRoomsListProps {
  apartments: INewBuildingApartment[];
}

export function ApartmentsList({ apartments }: IRoomsListProps) {
  return (
    <ul className={styles['apartments']}>
      {apartments.map((apartment, index) => (
        <li className={styles['apartments__item']} key={index}>
          <InlineText2>{apartment.title}</InlineText2>
          <span className={styles['apartments__line']} />
          <InlineText2>{apartment.value}</InlineText2>
        </li>
      ))}
    </ul>
  );
}
